/**
 * EnrollmentsList Messages
 *
 * This contains all the text for the EnrollmentsList component.
 */
import { defineMessages } from 'react-intl';

const scope = 'app.workspace.cohort.enrollments';

export default defineMessages({
  listColumnHeaderTextName: {
    id: `${scope}.list.columns.headers.names.Name`,
    defaultMessage: 'Name',
  },
  listColumnHeaderTextEmail: {
    id: `${scope}.list.columns.headers.names.Email`,
    defaultMessage: 'Email',
  },
  listColumnHeaderTextEnrollmentDate: {
    id: `${scope}.list.columns.headers.names.EnrollmentDate`,
    defaultMessage: 'Enrollment Date',
  },
  listColumnHeaderTextEnrollmentType: {
    id: `${scope}.list.columns.headers.names.EnrollmentType`,
    defaultMessage: 'Enrollment Type',
  },
});
